<template>
  <div
    :style="{ width: `${width}px`, height: `${height}px`, backgroundColor: color }"
    class="flex shrink-0 items-center justify-center rounded-full font-medium"
    :class="[fontSize, isLight ? 'text-gray-900' : 'text-white']"
  >
    {{ name[0] }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { isColorLight } from '@/shared/lib/misc';

const props = withDefaults(
  defineProps<{
    name?: string;
    color?: string;
    width?: string;
    height?: string;
  }>(),
  { name: '', color: '#0044f0', width: '32', height: '32' },
);

const fontSize = computed(() => {
  if (Number(props.width) >= 80) {
    return 'text-4xl';
  }
  if (Number(props.width) >= 64) {
    return 'md:text-2xl';
  }
  if (Number(props.width) >= 48) {
    return 'md:text-xl';
  }
  return 'text-sm';
});

const isLight = computed(() => isColorLight(props.color));
</script>
